import { render, staticRenderFns } from "./RecipeContentSectionModule.vue?vue&type=template&id=46acb0b4&"
import script from "./RecipeContentSectionModule.vue?vue&type=script&lang=js&"
export * from "./RecipeContentSectionModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports